module.exports = __webpack_public_path__ + "static/media/incident_category-security.9e74d001.svg";